import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const StGradientContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '48px 24px',
  [theme.breakpoints.down('md')]: {
    padding: '48px 24px',
  },
}));

export const StContentWrapper = styled(Box)(({ theme }) => ({
  id: 'container',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1.5rem',
  maxWidth: '900px',
  width: '100%',
  marginInline: 'auto',
  textAlign: 'center',

  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    textAlign: 'left',
    gap: '1rem',
  },
}));

export const StHeading = styled(Typography)(({ theme }) => ({
  color: '#002B45',
  fontFamily: '"Noto Sans", sans-serif',
  fontWeight: 700,
  fontStyle: 'normal',
  fontSize: '40px !important',
  lineHeight: '45px',
  letterSpacing: 0,
  textAlign: 'center',
  width: '100%',
  // [theme.breakpoints.down('md')]: {
  //   maxWidth: '80%',
  // },
  [theme.breakpoints.down('sm')]: {
    fontSize: '32px',
    lineHeight: '110%',
    textAlign: 'left',
  },
}));

export const StContentBox = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '640px',
  color: '#2B5B79',
  fontFamily: theme.typography.fontFamily,
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.4px',
  textAlign: 'center',
  '& p, & li, & span, & a': {
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    textAlign: 'inherit',
    color: 'inherit',
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left',
  },
}));
